/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/Dashboard.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/floor',
          name: 'floor',
          component: () => import('./views/Floor.vue'),
          meta: {
            rule: 'staff'
          }
        },

        {
          path: '/batch',
          name: 'batch',
          component: () => import('./views/Batch.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/batch/:id',
          name: 'batch-id',
          component: () => import('./views/BatchID.vue'),
          meta: {
            rule: 'staff'
          }
        },

        {
          path: '/work-center',
          name: 'work-center',
          component: () => import('./views/WorkCenter.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/work-center/:id',
          name: 'work-center-id',
          component: () => import('./views/WorkCenterID.vue'),
          meta: {
            rule: 'staff'
          }
        },

        {
          path: '/materials',
          name: 'materials',
          component: () => import('./views/Materials.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/materials/outputs',
          name: 'output-materials',
          component: () => import('./views/OutputMaterials.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/materials/:id/inputs',
          name: 'input-materials',
          component: () => import('./views/InputMaterials.vue'),
          meta: {
            rule: 'staff'
          }
        },

        {
          path: '/process/furnace',
          name: 'furnace',
          component: () => import('./views/process/Furnace.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/process/furnace/:id',
          name: 'furnace-id',
          component: () => import('./views/process/FurnaceID.vue'),
          meta: {
            rule: 'staff'
          }
        },

        {
          path: '/process/press',
          name: 'press',
          component: () => import('./views/process/Press.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/process/press/:id',
          name: 'press-id',
          component: () => import('./views/process/PressID.vue'),
          meta: {
            rule: 'staff'
          }
        },

        {
          path: '/process/roller',
          name: 'roller',
          component: () => import('./views/process/Roller.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/process/roller/:id',
          name: 'roller-id',
          component: () => import('./views/process/RollerID.vue'),
          meta: {
            rule: 'staff'
          }
        },

        {
          path: '/process/draw',
          name: 'draw',
          component: () => import('./views/process/Draw.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/process/draw/:id',
          name: 'draw-id',
          component: () => import('./views/process/DrawID.vue'),
          meta: {
            rule: 'staff'
          }
        },

        {
          path: '/process/wind',
          name: 'wind',
          component: () => import('./views/process/Wind.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/process/wind/:id',
          name: 'wind-id',
          component: () => import('./views/process/WindID.vue'),
          meta: {
            rule: 'staff'
          }
        },

        {
          path: '/process/ipqc',
          name: 'ipqc',
          component: () => import('./views/process/IPQC.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/process/ipqc/:id',
          name: 'ipqc-id',
          component: () => import('./views/process/IPQCID.vue'),
          meta: {
            rule: 'staff'
          }
        },

        {
          path: '/staging/message',
          name: 'staging-message',
          component: () => import('./views/staging/Message.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/staging/bom',
          name: 'staging-bom',
          component: () => import('./views/staging/BOM.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/staging/prod',
          name: 'staging-prod',
          component: () => import('./views/staging/Prod.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/staging/route',
          name: 'staging-route',
          component: () => import('./views/staging/Route.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/staging/raf',
          name: 'staging-raf',
          component: () => import('./views/staging/RAF.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/staging/pick',
          name: 'staging-pick',
          component: () => import('./views/staging/Pick.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/staging/card',
          name: 'staging-card',
          component: () => import('./views/staging/Card.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/staging/form',
          name: 'staging-form',
          component: () => import('./views/staging/Form.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/staging/form/:id',
          name: 'staging-form-id',
          component: () => import('./views/staging/FormID.vue'),
          meta: {
            rule: 'staff'
          }
        },

        {
          path: '/staging/form/:id/furnace',
          name: 'staging-form-id-furnace',
          component: () => import('./views/staging/furnace/FurnaceView.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/form/:id/furnace',
          name: 'form-id-furnace',
          component: () => import('./views/staging/furnace/FurnaceView.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Form', url: '/staging/form'},
              {title: 'Furnace', active: true}
            ],
            pageTitle: 'Furnace Form',
            rule: 'staff'
          }
        },

        {
          path: '/staging/form/:id/press',
          name: 'staging-form-id-press',
          component: () => import('./views/staging/press/PressView.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/form/:id/press',
          name: 'form-id-press',
          component: () => import('./views/staging/press/PressView.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Form', url: '/staging/form'},
              {title: 'Press', active: true}
            ],
            pageTitle: 'Press Form',
            rule: 'staff'
          }
        },

        {
          path: '/staging/form/:id/roller',
          name: 'staging-form-id-roller',
          component: () => import('./views/staging/roller/RollerView.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/form/:id/roller',
          name: 'form-id-roller',
          component: () => import('./views/staging/roller/RollerView.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Form', url: '/staging/form'},
              {title: 'Roller', active: true}
            ],
            pageTitle: 'Roller Form',
            rule: 'staff'
          }
        },

        {
          path: '/staging/form/:id/drawing',
          name: 'staging-form-id-drawing',
          component: () => import('./views/staging/drawing/DrawingView.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/form/:id/drawing',
          name: 'form-id-drawing',
          component: () => import('./views/staging/drawing/DrawingView.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Form', url: '/staging/form'},
              {title: 'Drawing', active: true}
            ],
            pageTitle: 'Drawing Form',
            rule: 'staff'
          }
        },

        {
          path: '/staging/form/:id/winding',
          name: 'staging-form-id-winding',
          component: () => import('./views/staging/winding/WindingView.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/form/:id/winding',
          name: 'form-id-winding',
          component: () => import('./views/staging/winding/WindingView.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Form', url: '/staging/form'},
              {title: 'Winding', active: true}
            ],
            pageTitle: 'Winding Form',
            rule: 'staff'
          }
        },

        {
          path: '/users',
          name: 'users',
          component: () => import('./views/Users.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/activity',
          name: 'activity',
          component: () => import('./views/Activity.vue'),
          meta: {
            rule: 'staff'
          }
        },
        {
          path: '/setting',
          name: 'setting',
          component: () => import('./views/Setting.vue'),
          meta: {
            rule: 'admin'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/auth/Login.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/forgot',
          name: 'forgot',
          component: () => import('@/views/auth/ForgotPassword.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/reset-password',
          name: 'reset-password',
          component: () => import('@/views/auth/ResetPassword.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/not-authorized',
          name: 'not-authorized',
          component: () => import('@/views/auth/NotAuthorized.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/lock',
          name: 'lock',
          component: () => import('@/views/auth/LockScreen.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/device',
          name: 'device',
          component: () => import('@/views/auth/Device.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/maintenance',
          name: 'maintenance',
          component: () => import('@/views/auth/Maintenance.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/coming-soon',
          name: 'coming-soon',
          component: () => import('@/views/auth/ComingSoon.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/not-found',
          name: 'error-404',
          component: () => import('@/views/auth/Error404.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/server-down',
          name: 'error-500',
          component: () => import('@/views/auth/Error500.vue'),
          meta: {
            rule: 'guest'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/not-found'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
